module.exports = __webpack_public_path__ + "img/certificateBack.7bee733.jpg";